
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AccountDetailViewModel, BudgetAmountsViewModel, BudgetCodeFiscalViewModel, BudgetCodeSearchCriteria, ClassMetadata, ExecutionResult } from "@tylertech/tyler-api-types";

/**
 * BudgetCodeFiscalService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class BudgetCodeFiscalService {
    private readonly $apiService = inject(ApiService);
    
    GetAccountDetail(pFundSearchViewModel: BudgetCodeSearchCriteria): Promise<ExecutionResult<AccountDetailViewModel[]>> {
        return this.$apiService.sendAuth("IBudgetCodeFiscalService/GetAccountDetail", pFundSearchViewModel);
    }
    GetBudgetCodeFiscal(pStringId: string): Promise<BudgetCodeFiscalViewModel> {
        return this.$apiService.sendAuth("IBudgetCodeFiscalService/GetBudgetCodeFiscal", pStringId);
    }
    GetBudgetCodeFiscalMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IBudgetCodeFiscalService/GetBudgetCodeFiscalMetadata");
    }
    GetChartBudgetData(pFundSearchViewModel: BudgetCodeSearchCriteria): Promise<ExecutionResult<BudgetAmountsViewModel[]>> {
        return this.$apiService.sendAuth("IBudgetCodeFiscalService/GetChartBudgetData", pFundSearchViewModel);
    }
}
